import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Row,Button, Form, FormGroup, Label, Card, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import routes from "../../../routers/routes";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updateUserTitle, usersTitle } from "../../../constants";
const UpdateUser = () => {
  const navigate = useNavigate();
  const { Id } = useParams(); // Get user ID from URL
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');

  // Fetch user data when component mounts
  useEffect(() => {
    const fetchUser = async () => {
      try {
        
        const response = await ApiService.axiosApi(`/auth/${Id}`, {
          method: 'GET',
        });

        if (response.success) {
          // Pre-fill form with user data
          
          setValue('UserName', response.data.userName);
          setValue('Email', response.data.email);
          setValue('PhoneNumber', response.data.phoneNumber);
          setSelectedRole(response.data.role);
        } else {
          toast.error("Failed to fetch user details");
          navigate(routes.Users);
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch user details");
        navigate(routes.Users);
      }
    };

    if (Id) fetchUser();
  }, [Id, setValue, navigate]);

  const toggleDropdown = () => setDropdownOpen(prev => !prev);

  const handleSelectRole = (role: string) => {
    setSelectedRole(role);
  };

  const onSubmit = async (data: any) => {
    try {
      console.log(Id);
      const updateData = {
        UserName: data.UserName,
        Email: data.Email,
        PhoneNumber: data.PhoneNumber,
        role: selectedRole
      };

      const response = await ApiService.axiosApi(`auth/${Id}`, {
        method: 'PUT',
        
        data: updateData
      });

      if (response.success) {
        toast.success("User updated successfully");
        navigate(routes.Users); // Go back to users list
      } else {
        toast.error(response.data.message || "Failed to update user");
      }
    } catch (error: any) {
      toast.error(error.message || "Failed to update user");
    }
  };

  return (
    <>
    
    <div style = {{width :'100%' , height : "400px"}}>
      <Card className="p-5 pt-1" style ={ { height : "400px"}}>
        <CommonCardHeader title="Update User" headClass="pb-3" />
       
          <Form onSubmit={handleSubmit(onSubmit)} >
            <FormGroup>
              <Label className="col-form-label">Name</Label>
              <input
                className="form-control"
                type="text"
                {...register("UserName", {
                  required: "Name is required",
                  minLength: {
                    value: 2,
                    message: "Name must be at least 2 characters"
                  }
                })}
              />
              {errors.UserName && <p className="text-danger mt-1">{errors.UserName.message?.toString()}</p>}
            </FormGroup>
             
            <Row className="mb-3">
  <Col md={6}>
    <FormGroup>
      <Label className="col-form-label">Email</Label>
      <input
        className="form-control"
        type="email"
        {...register("Email", {
          required: "Email is required",
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address"
          }
        })}
      />
      {errors.Email && (
        <p className="text-danger mt-1">
          {errors.Email.message?.toString()}
        </p>
      )}
    </FormGroup>
  </Col>

  <Col md={6}>
    <FormGroup>
      <Label className="col-form-label">Phone Number</Label>
      <input
        className="form-control"
        type="tel"
        
        {...register("PhoneNumber", {
          required: "Phone number is required",
          pattern: {
            value: /^[0-9]{10}$/,
            message: "Please enter a valid 10-digit phone number"
          }
        })}
      />
      {errors.PhoneNumber && (
        <p className="text-danger mt-1">
          {errors.PhoneNumber.message?.toString()}
        </p>
      )}
    </FormGroup>
  </Col>
</Row>

            <FormGroup>
              <Label className="col-form-label">Role</Label>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle 
                color="primary"
                className="custom-dropdown-toggle d-flex align-items-center justify-content-between" 
                style={{
                  backgroundColor: '#007bff',
                  borderColor: '#007bff',
                  color: '#fff',
                  fontWeight: 500,
                  borderRadius: '6px',
                  padding: '8px 16px',
                  width: '200px',
                }}>
                  {selectedRole || "Select Role"}
                </DropdownToggle>
                <DropdownMenu
                  className="custom-dropdown-menu"
                  style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    padding: '8px 0',
                    
                  }}>
                  <DropdownItem onClick={() => handleSelectRole("Administrator")}>Administrator</DropdownItem>
                  <DropdownItem onClick={() => handleSelectRole("Operator")}>Operator</DropdownItem>
                  <DropdownItem onClick={() => handleSelectRole("Engineer")}>Engineer</DropdownItem>
                  <DropdownItem onClick={() => handleSelectRole("Client")}>Client</DropdownItem>
                  <DropdownItem onClick={() => handleSelectRole("Farmer")}>Farmer</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </FormGroup>

            <div className="form-group mb-0">
              <div className="d-flex justify-content-start mt-4">
              <Button color="primary" type="submit" className="me-2">
                  Update User
                </Button>
                <Button color="danger" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                
              </div>
            </div>
          </Form>
        
      </Card>
    </div>
    </>
  );
};

export default UpdateUser;
